// @import dependencies
import React, {Component} from 'react'
import { connect } from 'react-redux'
import { CombinedReducers as IState } from 'app_events/index'
// @end

// @import components
import {OffercardCommonLayout} from 'app_components/commons/offercard'
// @end

// @import events
// @end

// @import utils
// @end

// @import services
// @end

// @import types
import {ICourse} from 'app_types/campus/academic/courseTypes'
// @end

// @ADD Component types
interface IOffercardCommonProps {
  course: ICourse
  list?: boolean
  link?: string
  share?: string
  hidePrice?: boolean
  hideValidUntil?: boolean
  hideTaxesText?: boolean
  hideInfoIcon?: boolean
}
interface IOffercardCommonState {}

// @INFO: Connect react storage state
const mapStatesToProps = (state: IState) => {return state}

class OffercardCommon extends Component<IOffercardCommonProps, IOffercardCommonState> {

  /*===============================================
  =            Estructura de un metodo            =
  ================================================
    // La estructura de un metodo debe ser la siguiente:
    methodName = () => {}
  /*======  End of Estructura de un metodo  =====*/

  constructor(props: IOffercardCommonProps) {
    super(props)
    this.state = {}
  }

  /**
   * Evento que se ejecuta cuando el componente es montado
   */
  componentDidMount = async () => {}

  /**
   * Evento que se ejecuta cuando el componente es desmontado
   */
  componentWillUnmount = () => {}

  /**
   * Evento que se ejecuta cuando el componente es actualizado
   */
  componentDidUpdate = () => {}

  // @Add custom methods

  render() {
    return(
      <OffercardCommonLayout
        course={this.props.course}
        list={this.props.list}
        link={this.props.link}
        share={this.props.share}
        hidePrice={this.props.hidePrice}
        hideValidUntil={this.props.hideValidUntil}
        hideTaxesText={this.props.hideTaxesText}
        hideInfoIcon={this.props.hideInfoIcon}
      />
    )
  }
}

export default connect(mapStatesToProps)(OffercardCommon)
